// import store from '@/store/store';

export default {
    // HandleErrors (error, message = 'Error occured!') {
    //     if(error.response) {
    //         if(error.response.status === 401 || error.response.status === 403) {
    //             store.dispatch('dialog/showLoginDialog');
    //         } else if(error.response.status === 404) {
    //             store.dispatch({
    //                 type: 'dialog/showMessageDialog',
    //                 messageType: 'error',
    //                 message: 'Resource not found!'
    //             });
    //         } else if (error.response.data && 'message' in error.response.data) {
    //             store.dispatch({
    //                 type: 'dialog/showMessageDialog',
    //                 messageType: 'error',
    //                 message: error.response.data['message']
    //             });
    //         } else {
    //             store.dispatch({
    //                 type: 'dialog/showMessageDialog',
    //                 messageType: 'error',
    //                 message: message
    //             });
    //         }
    //     } else if(error.request) {
    //         store.dispatch({
    //             type: 'dialog/showMessageDialog',
    //             messageType: 'error',
    //             message: 'Request error!'
    //         });
    //     } else {
    //         store.dispatch({
    //             type: 'dialog/showMessageDialog',
    //             messageType: 'error',
    //             message: 'Unknown error occured!'
    //         });
    //     }
    // },
    HandleErrors(error) {
        let err_msg = '';
        if (error.response.data.message) {
            err_msg = error.response.data.message;
        } else if (error.response.data.detail) {
            err_msg = error.response.data.detail;
        } else {
            err_msg = "There was a problem with the request";
        }

        if (error.response.status === 500) {
            err_msg = err_msg + "<br>Please contact help@vectorbyte.org to report this issue."
            return err_msg;
        } 
        // When doi.org finds an invalid DOI:
        else if (error.response.data.responseCode === 100){
            err_msg = "This DOI cannot be found in the DOI System. Possible reasons are:" 
            + "<br><ul><li>The DOI is incorrect in your source.</li><li>The DOI was copied incorrectly.</li><li>The DOI has not been activated yet.</li></ul>" 
            + "Please cross-check the format."
            return err_msg;
        }
        else {
            err_msg = err_msg + "<br>If you think this is an error, please contact us at help@vectorbyte.org."
            return err_msg;
        }     
    },
}